export default "__VITE_ASSET__C5ki1tHf__"